import Vue from "vue";
import VueSlickCarousel from "vue-slick-carousel";
import { productTemplate } from "./templates/productTemplateCarousel";

const debounce = require("lodash/debounce");

const AlternativeProductsCarouselComponent = Vue.extend({
    template: `
        <div class="alternative-products-carousel-container">
            <div class="w-100" v-if="items && items.length > 0">
                <form class="alternative-products-grid-wrapper alternative-products-carousel-form" id="alternative-products-carousel-form" name="alternative-products-carousel-form" :action="resources.applyCustomerBenefits">
                    <div class="alternative-products-title my-3">
                        <h3 class="pwc-font--primary-bold alternative-products-carousel-title pt-2 px-4 mx-3 mx-md-2">{{headerTitle ? headerTitle : ""}}</h3>
                    </div>
                    <VueSlickCarousel v-bind="settings" @init="onInitCarousel">
                        <template #prevArrow="arrowOption">
                            <div class="custom-arrow">
                                <span v-html="prevArrow" />
                            </div>
                        </template>
                        <product-item-carousel
                            v-for="(item, index) in items"
                            :resources="resources"
                            :item="item"
                            :cssClass="cssClassAvailableProduct"
                            :showSeparator="index < items.length - 1"
                            :cartIcon="cartIcon"
                            :showAddToCartButton="true"
                            :origID="originalProduct.id"
                            :key="index"
                        />
                        <template #nextArrow="arrowOption">
                            <div class="custom-arrow">
                                <span v-html="nextArrow" />
                            </div>
                        </template>
                        <template #customPaging="page">
                            <button type="button"></button>
                        </template>
                    </VueSlickCarousel>
                </form>
            </div>
            <div class="w-100 not-alternatives" v-else>
                {{notAvailableAlternativeProductsMessage}}
            </div>
        </div>`,
    components: {
        VueSlickCarousel,
        productTemplate
    },
    methods: {
        onInitCarousel: debounce(function () {
            const alternativeProductsCarouselWrapper = $(".alternative-products-grid-wrapper:not(.alternative-products-one)");
            if (alternativeProductsCarouselWrapper.length > 0) {
                alternativeProductsCarouselWrapper.each(function (key, item) {
                    const alternativeProductsCarouselTrack = item.querySelector(".slick-track");

                    if (alternativeProductsCarouselTrack.childElementCount < 5) {
                        item.classList.add("alternative-products-one");
                    }
                });
            }
            this.updateDotsContainerSpacing();
        }, 200),
        // Adds bottom spacing in order for the dots to fit under the carousel
        updateDotsContainerSpacing() {
            const $alternativeProductsCarousel = $("#alternative-products-carousel-form");
            const $alternativeProductsDots = $alternativeProductsCarousel.find(".slick-dots");
            const dotsHeight = $alternativeProductsDots.height();

            $alternativeProductsCarousel.css("marginBottom", dotsHeight);
            $alternativeProductsDots.css("top", "100%");
        }
    }
});

export default AlternativeProductsCarouselComponent;
